import { render } from "./ContextMenu.vue?vue&type=template&id=1f318536"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=1f318536&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__